const state = () => ({
  bFiltrarActive : false,      // Guarda el estado de la seccion de filtro
  oParamsFiltro : {},           // almacena el objeto completo
  aListadoFiltrosFinal: [],     // se guarda el arreglo llamado Nombre filtros = Nombrefiltros con el cual se muestran los chips
  aFiltrosActivos: [],          //  
  nPagina : 1,                  // Indica el numero de la pagina de la cual partimos 
  bCargarStorage : false,       // Esta variable se emplea para indicar a Filterseccion componente, de cargar lo que tenga en storage.
  aInfoFiltrada : [],           // almacena la info de los filtro dentro de un arreglo estructurado donde la propiedad es el filtro y el valor lo que se esta filtrado eje: Cliente: Primer cliente No tienen igualdad con niguna variable del componente filterseccion
  nItemPerPage  : 10,           // Indica el numero de registros por página seleccionados
})

const getters = {
  getoParamsFiltro: ( state ) => {
    return state.oParamsFiltro;
  },
  getbFiltrarActive: ( state ) => {
    return state.bFiltrarActive;
  },
  getaListadoFiltrosFinal: ( state ) => {
    return state.aListadoFiltrosFinal;
  },
  getaFiltrosActivos: ( state ) => {
    return state.aFiltrosActivos;
  },
  getnPagina: ( state ) => {
    return state.nPagina;
  },
  getbCargarStorage: ( state ) => {
    return state.bCargarStorage;
  },
  getaInfoFiltrada: ( state ) => {
    return state.aInfoFiltrada;
  },
  getnItemsPerPage: (state) => {
    return state.nItemPerPage;
  }
} 

const mutations = {
  SALVAR_OPARAMSFILTRO : ( state, oParamsFiltro ) => {
    state.oParamsFiltro = oParamsFiltro;
  },
  SALVAR_bFiltrarActive : ( state, bFiltrarActive ) => {
    state.bFiltrarActive = bFiltrarActive;
  },
  SALVAR_ALISTADOFILTROS : ( state, aListadoFiltrosFinal ) => {
    state.aListadoFiltrosFinal = aListadoFiltrosFinal;
  },
  SALVAR_AFILTROSACTIVOS : ( state, aFiltrosActivos ) => {
    state.aFiltrosActivos = aFiltrosActivos;
  },
  SALVAR_nPAGINA : ( state, nPagina ) => {
    state.nPagina = nPagina;
  },
  SALVAR_nITEMSPERPAGE : ( state, value ) => {
    state.nItemPerPage = value;
  },
  SALVAR_bCARGARSTORAGE : ( state, bCargarStorage ) => {
    state.bCargarStorage = bCargarStorage;
  },
  CLEARALL : ( state ) => {
    state.bFiltrarActive = false
    state.aListadoFiltrosFinal = []
    state.aFiltrosActivos= []
    state.oFiltro = {}
    // state.nPagina = 1
    state.bCargarStorage = false
  },
  SALVAR_aINFOFILTRADA : ( state, oInfo ) => {
    // Antes de guardar valido que no este.
    const auxIndiceValidacion = state.aInfoFiltrada.findIndex(elemento => elemento.Campo == oInfo.Campo)
    if(auxIndiceValidacion === -1 ){
      state.aInfoFiltrada.push(oInfo)
    } else {
      state.aInfoFiltrada.splice(auxIndiceValidacion,1,oInfo)
    } 
  },
  CLEAR_aINFOFILTRADA : ( state ) => {
    state.aInfoFiltrada = []
  },
  RELOAD_aINFOFILTRADA : ( state, aInfo ) => {
    state.aInfoFiltrada = aInfo
  },
  DELETE_aINFOFILTRADA : ( state, sCampo ) => {
    const auxIndiceValidacion = state.aInfoFiltrada.findIndex(elemento => elemento.Campo == sCampo)
    if(auxIndiceValidacion !== -1 ){
      state.aInfoFiltrada.splice(auxIndiceValidacion,1)
    }
  }
}

const actions = {
  save_oParamsFiltro( {commit}, oParamsFiltro ) {
    commit( "SALVAR_OPARAMSFILTRO", oParamsFiltro);
  },
  save_bFiltrarActive( {commit}, bFiltrarActive ) {
    commit( "SALVAR_bFiltrarActive", bFiltrarActive);
  },
  save_aListadoFiltrosFinal( {commit}, aListadoFiltrosFinal ) {
    commit( "SALVAR_ALISTADOFILTROS", aListadoFiltrosFinal);
  },
  save_aFiltrosActivos( {commit}, aFiltrosActivos ) {
    commit( "SALVAR_AFILTROSACTIVOS", aFiltrosActivos);
  },
  save_nPagina( {commit}, nPagina ) {
    commit( "SALVAR_nPAGINA", nPagina);
  },
  save_nItemsPerPage({commit}, value) {
    commit('SALVAR_nITEMSPERPAGE', value)
  },
  save_bCargarStorage( {commit}, bCargarStorage ) {
    commit( "SALVAR_bCARGARSTORAGE", bCargarStorage);
  },
  ClearAll( {commit} ) {
    commit( "CLEARALL",);
  },
  save_aInfoFiltrada( {commit}, oInfo ) {
    commit( "SALVAR_aINFOFILTRADA", oInfo);
  },
  Clear_aInfoFiltrada ({commit}){
    commit("CLEAR_aINFOFILTRADA")
  },
  Reload_aInfoFiltrada ({commit}, aInfo){
    commit("RELOAD_aINFOFILTRADA", aInfo)
  },
  delete_aInfoFiltrada ({commit}, sCampo){
    // elmina una propiedad indicada
    commit("DELETE_aINFOFILTRADA", sCampo)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}